<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
        :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" :width="800">
        <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-input v-model:value="form.id" />
                </a-form-item>
            </div>
            <a-row :gutter="20">
                <a-col :span="24">
                    <a-form-item label="头像" name="headImg">
                        <img-upload v-model:value="form.headImg" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="姓名" name="realName">
                        <a-input v-model:value="form.realName" placeholder="请输入" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="性别" name="sex">
                        <a-radio-group v-model:value="form.sex">
                            <a-radio :value="0">男</a-radio>
                            <a-radio :value="1">女</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="出生日期" name="birth">
                        <date-picker v-model:value="form.birth" placeholder="请选择" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="联系电话" name="telephone">
                        <a-input v-model:value="form.telephone" placeholder="请输入" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="邮箱" name="email">
                        <a-input v-model:value="form.email" placeholder="请输入" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="户口所在地" name="prov">
                        <city-select-all v-model:prov="form.prov" v-model:city="form.city" v-model:county="form.county"
                            placeholder="请选择" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="详细地址" name="address">
                        <a-input v-model:value="form.address" placeholder="请输入" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="身份证号" name="idCard">
                        <a-input v-model:value="form.idCard" placeholder="请输入" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="学历" name="edu">
                        <DictSelect v-model:value="form.edu" :dict-name="education.EDUCATION_BACKGROUND"
                            placeholder="请选择" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="所学专业" name="major">
                        <DictSelect v-model:value="form.major" :dict-name="education.MAJOR" placeholder="请选择" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="毕业院校" name="graduationUniversity">
                        <a-input v-model:value="form.graduationUniversity" placeholder="请输入" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="职务" name="position">
                        <a-input v-model:value="form.position" placeholder="请输入" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="职称" name="talentTitle">
                        <DictSelect v-model:value="form.talentTitle" :dict-name="education.TALENTTITLE" placeholder="请选择" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="参加工作年份" name="joinJobTime">
                        <date-picker v-model:value="form.joinJobTime" placeholder="请选择" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="个人履历" name="resume">
                        <a-textarea v-model:value="form.resume" placeholder="请输入" :rows="4" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="个人简介" name="description">
                        <a-textarea v-model:value="form.description" placeholder="请输入" :rows="4" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="资质证书" name="certification">
                        <a-textarea v-model:value="form.certification" placeholder="请输入" :rows="4" />
                    </a-form-item>
                </a-col>
                <!--可编辑区域 end-->
            </a-row>
        </a-form>

    </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import { formMixin } from "@/mixins";
import { talentApi } from "@/api/companyService";
import { education, innovation } from "@/config/variableConfig"
import DictSelect from "@/components/other/DictSelect";
import ImgUpload from "@/components/form/upload/ImgUpload";
import DatePicker from "@/components/form/datePicker/DatePicker";
import CitySelectAll from "@/components/form/select/AllCitySelect";

export default {
    name: "AddOrEditModal",
    components: { DatePicker, ImgUpload, DictSelect, CitySelectAll },

    mixins: [formMixin],
    data() {
        return {
            innovation,
            education,
            options: [],
            form: {
                id: null,
            },
            rules: {
                id: [],
                headImg: [],
                realName: [],
                sex: [],
                birth: [],
                telephone: [dataCheck.mobile_phone],
                edu: [],
                email: [dataCheck.email],
                prov: [],
                city: [],
                county: [],
                address: [],
                major: [],
                idCard: [dataCheck.id_num],
                position: [],
                talentTitle: [],
                joinJobTime: [],
                resume: [],
                graduationUniversity: [],
                description: [],
                certification: [],
            },
            submitUrl: talentApi.saveOrUpdate
        }
    },
    created() {
    },
    methods: {

    },
}
</script>
<style scoped lang="less"></style>
